import React from "react";

interface AccountIconProps {
  className?: string;
  color?: string;
}

export const AccountIcon: React.FC<AccountIconProps> = ({
  className = "",
  color = "currentColor",
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 24"
      width="26"
      height="24"
      fill="none"
    >
      {/* 头部 */}
      <ellipse
        cx="13"
        cy="7.5"
        rx="5"
        ry="5"
        fill={color}
      />
      {/* 身体/肩膀 */}
      <path
        d="M4.5 21.5C4.5 21.5 5.5 13 13 13C20.5 13 21.5 21.5 21.5 21.5C21.5 22.5 20.5 23.5 19 23.5H7C5.5 23.5 4.5 22.5 4.5 21.5Z"
        fill={color}
      />
    </svg>
  );
};

export default AccountIcon;
